import {
    CREATE_SECTION_FAILURE,
    CREATE_SECTION_REQUEST,
    CREATE_SECTION_SUCCESS,
    CREATE_USER_FORM_SECTION,
    DELETE_SECTION_FAILURE,
    DELETE_SECTION_REQUEST,
    DELETE_SECTION_SUCCESS,
    FETCH_SECTION_FAILURE,
    FETCH_SECTION_REQUEST,
    FETCH_SECTION_SUCCESS,
    FETCH_SINGLE_SECTION_FAILURE,
    FETCH_SINGLE_SECTION_REQUEST,
    FETCH_SINGLE_SECTION_SUCCESS,
    RESET_SECTION_USER_FORM,
    UPDATE_SECTION_FAILURE,
    UPDATE_SECTION_REQUEST,
    UPDATE_SECTION_SUCCESS
} from './section.actionsType';

export const SECTION = 'section';

let initialState = {
    loading: false,
    sectionData: [],
    userform: { fldSectionType: 'p' },
    selectedSectionData: {},
    errorMessage: '',
    iperrorMessage: ''
};



export let sectionReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_SECTION_REQUEST:
        case CREATE_SECTION_REQUEST:
        case FETCH_SINGLE_SECTION_REQUEST:
        case UPDATE_SECTION_REQUEST:
        case DELETE_SECTION_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SECTION_SUCCESS:
            const seen = new Set();
            const filteredPayload = updatePayload.filter(item => {
                const duplicate = seen.has(item.fldSection);
                seen.add(item.fldSection);
                return !duplicate;
            });
            return {
                ...state,
                loading: false,
                sectionData: filteredPayload
            };
        case RESET_SECTION_USER_FORM:
            return {
                ...state,
                selectedSectionData: {},
                userform: { fldSectionType: 'p' }
            };
        case CREATE_SECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldSectionType: 'p' }
            };
        case FETCH_SINGLE_SECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedSectionData: updatePayload,
                userform: updatePayload
            };
        case UPDATE_SECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedSectionData: {},
                userform: { fldSectionType: 'p' }
            };
        case DELETE_SECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedDefaultStyle: {},
                userform: { fldSectionType: 'p' }
            };
        case FETCH_SECTION_FAILURE:
        case CREATE_SECTION_FAILURE:
        case FETCH_SINGLE_SECTION_FAILURE:
        case UPDATE_SECTION_FAILURE:
        case DELETE_SECTION_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_SECTION:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        default:
            return state;
    }
};
